import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ariaLabel: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'minimizable-modal.modal-container.minimized.messaged.aria-label',
		defaultMessage: 'Minimized modal',
		description: 'Aria label for minimized modal',
	},
});
